import {
  useGetBillingCategoryByCommunity,
  useGetPropertyCategories,
} from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useMemo } from "react";

const useAddEdit = () => {
  const communityData = useSelector((state: RootState) => state.currentData.communityData);

  const { data: billingCategory, isLoading: isLoadingBillingCategory } =
    useGetBillingCategoryByCommunity({
      communityId: communityData?.communityId,
      queryParams: {
        enabled: !!communityData?.communityId
      }
    });

  const { data: propertyCategory, isLoading: isPropertyCategoryLoading } = useGetPropertyCategories({
    communityId: communityData?.communityId,
    queryParams: {
      enabled: !!communityData?.communityId
    }
  });

  const billingPropertyCategory = useMemo(() => {
    const propertyCategories = Array.from(
      new Map(
        billingCategory?.data
          .flatMap((item: any) => item.propertyCategories)
          .map((cat: any) => [cat.categoryId, cat])
      ).values()
    );
    return propertyCategories
  }, [billingCategory]);

  return {
    propertyCategory: propertyCategory?.data || [],
    isPropertyCategoryLoading,
    billingPropertyCategory,
    isLoadingBillingCategory,
  };
};

export default useAddEdit;
